angular.module('app', [
  'angular-google-adsense',
  'angularMoment',
  'bw.paging',
  'chart.js',
  'checklist-model',
  'infinite-scroll',
  'jkuri.timepicker',
  'monospaced.elastic',
  'ngCookies',
  'ngFileUpload',
  'ngResource',
  'ngRoute',
  'ngSanitize',
  'slickCarousel',
  'toastr',
  'ui.bootstrap',
  'xeditable',
  'ngMeta'
])
.constant('STRIPE_PK', 'pk_live_M3yEltaEOQXj73EWUH3Yj9ea00xYNfQrZU');
